'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nuiIntl = require('@concur/nui-intl');

var _trackClick = require('../HOCs/trackClick');

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/ReadMore.css') : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadMore = function ReadMore(_ref) {
  var text = _ref.text,
      isExpanded = _ref.isExpanded,
      expand = _ref.expand;

  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    expand();
  };

  var renderExpandLink = function renderExpandLink() {
    return _react2.default.createElement(
      'a',
      { href: '#', className: 'cnqr-muted', onClick: clickHandler },
      isExpanded ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ReadLess' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ReadMore' })
    );
  };

  var lines = text && text.split(/\r\n|\r|\n/g).length;

  var getMaxHeight = function getMaxHeight() {
    if (text && text.length < 293) {
      if (lines > 3) {
        return {
          maxHeight: lines * 18.5714 + 'px' // 18.5714 is the computed linehieght
        };
      }
    }
  };

  var renderButton = function renderButton() {
    if (text && (text.length > 293 || lines > 3)) {
      return _react2.default.createElement(
        'div',
        { className: 'ac-read-more ' + (isExpanded ? 'ac-read-more-expanded' : '') },
        renderExpandLink()
      );
    }
    return null;
  };

  return _react2.default.createElement(
    'div',
    { className: 'ac-read-more-container' },
    _react2.default.createElement(
      'div',
      {
        className: 'ac-read-more-text ' + (isExpanded ? 'ac-read-more-text-expanded' : ''),
        style: getMaxHeight()
      },
      text,
      renderButton()
    )
  );
};

ReadMore.propTypes = {
  text: _propTypes2.default.string.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  expand: _propTypes2.default.func.isRequired
};

exports.default = ReadMore;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ReadMore.js
// module id = 581
// module chunks = 0